module.exports = __webpack_public_path__ + "img/苦玄参.3feaed6d.jpg";